// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"2042f458","724":"52f3dd90"}[chunkId] + ".css";
};